import React from "react";
import { Navigate, Route } from "react-router-dom";

import NotasFiscaisEmitidasLayout from "../pages/Templates/Template-Administrativo/Financeiro/NotasFiscaisEmitidasLayout";
import RegrasFiscaisClientesLayout from "../pages/Templates/Template-Administrativo/Financeiro/RegrasFiscaisClientesLayout";
import ContasReceberLayout from "../pages/Templates/Template-Administrativo/Financeiro/ContasReceberLayout";
import ContasPagarLayout from "../pages/Templates/Template-Administrativo/Financeiro/ContasPagarLayout";
import ConciliacaoBancariaLayout from "../pages/Templates/Template-Administrativo/Financeiro/ConciliacaoBancariaLayout";
import FluxoCaixaLayout from "../pages/Templates/Template-Administrativo/Financeiro/FluxoCaixaLayout";
import ContratosRecorrenciasLayout from "../pages/Templates/Template-Administrativo/Financeiro/ContratosRecorrenciasLayout";
import RelatoriosFinanceirosLayout from "../pages/Templates/Template-Administrativo/Financeiro/RelatoriosFinanceirosLayout";

//import NotasFiscaisSaidaRetornoLayout from "../pages/Templates/Template-Administrativo/Financeiro/NotasFiscaisSaidaRetornoLayout";
import CobrancasLayout from "../pages/Templates/Template-Administrativo/Financeiro/CobrancasLayout";
import ComprasDespesasLayout from "../pages/Templates/Template-Administrativo/Financeiro/ComprasDespesasLayout";
import InvestimentosAtivosMonitoradosLayout from "../pages/Templates/Template-Administrativo/Financeiro/InvestimentosAtivosMonitoradosLayout";

export const financeiroRoutes = (
  <>
    {/* =========================================================
        FINANÇAS / GESTÃO FISCAL
        Módulo 91 - Gestão Fiscal
        ========================================================= */}

    <Route
      path="/financeiro/gestao-fiscal"
      element={
        <Navigate
          to="/financeiro/gestao-fiscal/notas-fiscais-emitidas"
          replace
        />
      }
    />

    <Route
      path="/financeiro/gestao-fiscal/notas-fiscais-emitidas"
      element={<NotasFiscaisEmitidasLayout />}
    />

    <Route
      path="/financeiro/investimentos"
      element={<NotasFiscaisEmitidasLayout />}
    />
    <Route
      path="/financeiro/investimentos/investimentos-ativos-monitorados"
      element={<InvestimentosAtivosMonitoradosLayout />}
    />

    <Route
      path="/financeiro/gestao-fiscal/regras-fiscais"
      element={<RegrasFiscaisClientesLayout />}
    />
    {/*
    <Route
      path="/financeiro/gestao-fiscal/notas-fiscais-saida-retorno"
      element={<NotasFiscaisSaidaRetornoLayout />}
    />

     Compatibilidade com rotas antigas de Gestão Financeira / Fiscal */}
    <Route
      path="/financeiro/gestao-fiscal/nfs"
      element={
        <Navigate
          to="/financeiro/gestao-fiscal/notas-fiscais-emitidas"
          replace
        />
      }
    />

    <Route
      path="/financeiro/gestao-fiscal/regras-fiscais"
      element={
        <Navigate to="/financeiro/gestao-fiscal/regras-fiscais" replace />
      }
    />

    <Route
      path="/financeiro/gestao-financeira/notas-fiscais-saida-retorno"
      element={
        <Navigate
          to="/financeiro/gestao-fiscal/notas-fiscais-saida-retorno"
          replace
        />
      }
    />

    <Route
      path="/financeiro/gestao-financeira/nfe-retorno"
      element={
        <Navigate
          to="/financeiro/gestao-fiscal/notas-fiscais-saida-retorno"
          replace
        />
      }
    />

    {/* =========================================================
        FINANÇAS / CONTAS A RECEBER
        Módulo 92 - Contas a Receber
        ========================================================= */}

    <Route
      path="/financeiro/contas-a-receber"
      element={
        <Navigate to="/financeiro/contas-a-receber/titulos-a-receber" replace />
      }
    />

    <Route
      path="/financeiro/contas-a-receber/contas-a-receber"
      element={<ContasReceberLayout />}
    />

    <Route
      path="/financeiro/contas-a-receber/cobrancas"
      element={<CobrancasLayout />}
    />

    {/* Compatibilidade com rota antiga */}
    <Route
      path="/financeiro/gestao-financeira/contas-a-receber"
      element={
        <Navigate to="/financeiro/contas-a-receber/titulos-a-receber" replace />
      }
    />

    <Route
      path="/financeiro/cobrancas"
      element={<Navigate to="/financeiro/contas-a-receber/cobrancas" replace />}
    />

    <Route
      path="/financeiro/gestao-financeira/cobrancas"
      element={<Navigate to="/financeiro/contas-a-receber/cobrancas" replace />}
    />

    {/* =========================================================
        FINANÇAS / CONTAS A PAGAR
        Módulo 93 - Contas a Pagar
        ========================================================= */}

    <Route
      path="/financeiro/contas-a-pagar"
      element={
        <Navigate to="/financeiro/contas-a-pagar/titulos-a-pagar" replace />
      }
    />

    <Route
      path="/financeiro/contas-a-pagar/titulos-a-pagar"
      element={<ContasPagarLayout />}
    />

    <Route
      path="/financeiro/contas-a-pagar/compras-despesas"
      element={<ComprasDespesasLayout />}
    />

    {/* Compatibilidade com rotas antigas */}
    <Route
      path="/financeiro/gestao-financeira/contas-a-pagar"
      element={
        <Navigate to="/financeiro/contas-a-pagar/titulos-a-pagar" replace />
      }
    />

    <Route
      path="/financeiro/compras-despesas"
      element={
        <Navigate to="/financeiro/contas-a-pagar/compras-despesas" replace />
      }
    />

    <Route
      path="/financeiro/gestao-financeira/compras-despesas"
      element={
        <Navigate to="/financeiro/contas-a-pagar/compras-despesas" replace />
      }
    />

    <Route
      path="/financeiro/compras"
      element={
        <Navigate to="/financeiro/contas-a-pagar/compras-despesas" replace />
      }
    />

    <Route
      path="/financeiro/gestao-financeira/compras"
      element={
        <Navigate to="/financeiro/contas-a-pagar/compras-despesas" replace />
      }
    />

    {/* =========================================================
        FINANÇAS / TESOURARIA E CAIXA
        Módulo 94 - Tesouraria e Caixa
        ========================================================= */}

    <Route
      path="/financeiro/tesouraria-e-caixa"
      element={
        <Navigate to="/financeiro/tesouraria-e-caixa/fluxo-de-caixa" replace />
      }
    />

    <Route
      path="/financeiro/tesouraria-e-caixa/fluxo-de-caixa"
      element={<FluxoCaixaLayout />}
    />

    <Route
      path="/financeiro/tesouraria-e-caixa/conciliacao-bancaria"
      element={<ConciliacaoBancariaLayout />}
    />

    {/* Compatibilidade com rotas antigas */}
    <Route
      path="/financeiro/fluxo-de-caixa"
      element={
        <Navigate to="/financeiro/tesouraria-e-caixa/fluxo-de-caixa" replace />
      }
    />

    <Route
      path="/financeiro/gestao-financeira/fluxo-de-caixa"
      element={
        <Navigate to="/financeiro/tesouraria-e-caixa/fluxo-de-caixa" replace />
      }
    />

    <Route
      path="/financeiro/conciliacao-bancaria"
      element={
        <Navigate
          to="/financeiro/tesouraria-e-caixa/conciliacao-bancaria"
          replace
        />
      }
    />

    <Route
      path="/financeiro/gestao-financeira/conciliacao-bancaria"
      element={
        <Navigate
          to="/financeiro/tesouraria-e-caixa/conciliacao-bancaria"
          replace
        />
      }
    />

    {/* =========================================================
        FINANÇAS / CONTRATOS E RECORRÊNCIAS
        Módulo 95 - Contratos e Recorrências
        ========================================================= */}

    <Route
      path="/financeiro/contratos-recorrencias"
      element={
        <Navigate
          to="/financeiro/contratos-recorrencias/contratos-recorrentes"
          replace
        />
      }
    />

    <Route
      path="/financeiro/contratos-recorrencias/contratos-recorrentes"
      element={<ContratosRecorrenciasLayout />}
    />

    {/* Compatibilidade com rota antiga */}
    <Route
      path="/financeiro/gestao-financeira/contratos-recorrencias"
      element={
        <Navigate
          to="/financeiro/contratos-recorrencias/contratos-recorrentes"
          replace
        />
      }
    />

    {/* =========================================================
        FINANÇAS / RELATÓRIOS FINANCEIROS
        Módulo 96 - Relatórios Financeiros
        ========================================================= */}

    <Route
      path="/financeiro/relatorios"
      element={
        <Navigate to="/financeiro/relatorios-financeiros/visao-geral" replace />
      }
    />

    <Route
      path="/financeiro/relatorios-financeiros"
      element={
        <Navigate to="/financeiro/relatorios-financeiros/visao-geral" replace />
      }
    />

    <Route
      path="/financeiro/relatorios-financeiros/visao-geral"
      element={<RelatoriosFinanceirosLayout />}
    />

    {/* Compatibilidade com rota antiga */}
    <Route
      path="/financeiro/gestao-financeira/relatorios"
      element={
        <Navigate to="/financeiro/relatorios-financeiros/visao-geral" replace />
      }
    />
  </>
);
